import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronThickLeft = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M8.99978 15.9994C8.99974 16.2622 9.05149 16.5225 9.15208 16.7652C9.25267 17.008 9.40013 17.2286 9.58603 17.4144L19.586 27.4144C19.7718 27.6001 19.9924 27.7473 20.2351 27.8477C20.4779 27.9481 20.738 27.9997 21.0007 27.9996C21.2633 27.9995 21.5234 27.9477 21.766 27.847C22.0087 27.7464 22.2291 27.599 22.4148 27.4132C22.6004 27.2273 22.7477 27.0068 22.8481 26.764C22.9485 26.5213 23.0001 26.2612 23 25.9985C22.9999 25.7358 22.948 25.4758 22.8474 25.2331C22.7468 24.9905 22.5993 24.7701 22.4135 24.5844L13.8285 15.9994L22.4135 7.4144C22.7886 7.03929 22.9994 6.53052 22.9994 6.00003C22.9994 5.46953 22.7886 4.96077 22.4135 4.58565C22.0384 4.21054 21.5296 3.9998 20.9991 3.9998C20.4687 3.9998 19.9599 4.21054 19.5848 4.58565L9.58478 14.5857C9.21011 14.9607 8.99969 15.4692 8.99978 15.9994Z" />
	</svg>
);

export default ChevronThickLeft;
